import { useTranslate } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Input } from 'module/ui/components/atoms/input/input';
import { faPage } from '@fortawesome/pro-regular-svg-icons';
import { Form, InputRef } from 'antd';
import { FC, useCallback, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const FormItem = styled(Form.Item)`
  margin-bottom: 0;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  padding: var(--spacing-02);
  width: 304px;
  .ant-form {
    flex: 1;
  }
`;
const TitleIcon = styled(FontAwesomeIcon)`
  color: var(--icon-secondary);
`;

interface DocumentTitleInputProps {
  value: string;
  onChange?: (value: string) => void;
  className?: string;
}
export const DocumentTitleInput: FC<DocumentTitleInputProps> = ({
  className,
  value,
  onChange,
}) => {
  const translate = useTranslate();
  const documentTitlePlaceholderText = translate('title.placeholder');
  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  const onAddOptionInputKeyDown = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.key === 'Enter') {
        form
          .validateFields()
          .then(({ documentTitle }) => {
            onChange?.(documentTitle);
          })
          .catch(() => {});
      }
    },
    [form, onChange],
  );
  const onAddOptionInputBlur = useCallback(() => {
    form
      .validateFields()
      .then(({ documentTitle }) => {
        onChange?.(documentTitle);
      })
      .catch(() => {
        form.setFields([
          {
            name: 'documentTitle',
            errors: [],
          },
        ]);
      });
  }, [form, onChange]);

  useEffect(() => {
    form.setFieldsValue({
      documentTitle: value,
    });
  }, [form, value]);

  return (
    <InputWrapper data-cy="document-title-input-wrapper">
      <TitleIcon
        icon={faPage}
        size={32}
        iconSize={16}
        color="transparent"
        data-cy="document-title-icon"
      />
      <Form
        layout="vertical"
        onSubmitCapture={(event) => {
          event.preventDefault();
        }}
        form={form}
        initialValues={{
          documentTitle: '',
        }}
        className={className}
      >
        <FormItem
          name={'documentTitle'}
          rules={[
            {
              required: true,
              message: (
                <FormattedMessage id="meeting_page_template.error.title_required" />
              ),
            },
          ]}
        >
          <Input
            data-cy="document-title-input"
            placeholder={documentTitlePlaceholderText}
            onKeyDown={onAddOptionInputKeyDown}
            onBlur={onAddOptionInputBlur}
            ref={inputRef}
          />
        </FormItem>
      </Form>
    </InputWrapper>
  );
};
